export default __webpack_public_path__ + "static/media/2.000e3b16.jpg";